import { render, staticRenderFns } from "./ProcessTwoOrderNew.vue?vue&type=template&id=4d90b2ba&scoped=true"
import script from "./ProcessTwoOrderNew.vue?vue&type=script&lang=js"
export * from "./ProcessTwoOrderNew.vue?vue&type=script&lang=js"
import style0 from "./ProcessTwoOrderNew.vue?vue&type=style&index=0&id=4d90b2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90b2ba",
  null
  
)

export default component.exports